import React from "react"
import Layout from "../components/Layout"
import QuoteForm from "../components/QuoteForm"

export default function Contact() {
  return (
    <Layout
      seo={{
        title: "Get a Tailored Quote | Greg Woodward Photography & Film",
        description:
          "Tell us about your project and get a tailored photography or video quote within 24 hours.",
        pathname: "/contact/",
      }}
    >
      <main className="service-page contact-page">
        <div className="page-intro">
          <div>
            <span className="service-label">Start a project</span>
            <h1>Get a tailored quote.</h1>
          </div>
          <p>
            Tell me a bit about what you need. No ballpark figures: a proper,
            itemised quote lands in your inbox once I've reviewed your brief.
            Prefer to talk first? Email{" "}
            <a href="mailto:info@gregwoodwardphoto.com">
              info@gregwoodwardphoto.com
            </a>{" "}
            or call 07921 085400.
          </p>
        </div>

        <QuoteForm />
      </main>
    </Layout>
  )
}
